import _ from 'lodashParts'
import constants from './constants'

function addTagAndDisplayNameFieldsIfNeeded(themeMap) {
    return _.flow(
        x => _.omitBy(x, (value, key) => !value.tag && !constants.DEFAULT_THEME_TAGS[key]),
        x => _.reduce(x, (result, value, key) => {
            result[key] = _.assign({tag: constants.DEFAULT_THEME_TAGS[key], displayName: constants.DEFAULT_THEME_DISPLAY_NAME[key]}, value)
            return result
        }, {})
    )(themeMap)
}

module.exports = {
    addTagAndDisplayNameFieldsIfNeeded
}



// WEBPACK FOOTER //
// ./src/utils/themeUtils.js